var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "el-row",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.historyBack },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "headDataForm",
                  attrs: {
                    model: _vm.headData,
                    "label-position": _vm.labelPosition,
                    "label-width": "140px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("apply.no") } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.headData.applyNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.headData, "applyNo", $$v)
                                  },
                                  expression: "headData.applyNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("apply.applyType"),
                                prop: "applyType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "handle-input",
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: true },
                                  model: {
                                    value: _vm.headData.applyType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.headData, "applyType", $$v)
                                    },
                                    expression: "headData.applyType",
                                  },
                                },
                                _vm._l(
                                  _vm.applyTypeList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: _vm._f("inputChoiceI18n")(item),
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("apply.subject") } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.headData.subject,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.headData, "subject", $$v)
                                  },
                                  expression: "headData.subject",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("apply.quotationType"),
                                prop: "quotationType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "handle-input",
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: true },
                                  model: {
                                    value: _vm.headData.quotationType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.headData,
                                        "quotationType",
                                        $$v
                                      )
                                    },
                                    expression: "headData.quotationType",
                                  },
                                },
                                _vm._l(
                                  _vm.quotationTypeList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: _vm._f("inputChoiceI18n")(item),
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "历史报价", name: "line" } },
                _vm._l(_vm.roundList, function (round, i) {
                  return _c(
                    "div",
                    { key: i },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 16 } },
                        [
                          _c("el-col", { attrs: { span: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("apply.round")) + "："),
                          ]),
                          _c("el-col", { attrs: { span: 1 } }, [
                            _vm._v(_vm._s(round.roundNumber)),
                          ]),
                          _c("el-col", { attrs: { span: 3 } }, [
                            _vm._v(
                              _vm._s(_vm.$t("apply.quoteSubmitDate")) + "："
                            ),
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 3 } },
                            [
                              _c("el-link", [
                                _vm._v(" " + _vm._s(round.submitDate) + " "),
                              ]),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("apply.roundRemark")) + "："),
                          ]),
                          _c("el-col", { attrs: { span: 4 } }, [
                            _vm._v(_vm._s(round.remark)),
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 2 } },
                            [
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showAttachmentDialogM(
                                        _vm.$t("apply.roundAttachment"),
                                        round.ttQuotationApplyRoundId,
                                        "QUOTATION_APPLY_ROUND"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("apply.roundAttachment"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 3 } },
                            [
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showAttachmentDialogM(
                                        _vm.$t("apply.quoteAttachment"),
                                        round.ttQuotationId,
                                        "QUOTATION",
                                        round.tmSupplierId
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("apply.quoteAttachment"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "ux-grid",
                        {
                          ref: "quotationLineTableDataRef",
                          refInFor: true,
                          attrs: {
                            data: round.quotationLineList,
                            "keep-source": "",
                            "max-height": "560",
                            "show-overflow": "tooltip",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "序号",
                              type: "index",
                              width: "60",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: _vm.$t("apply.supplier"),
                              field: "supplierName",
                              "min-width": "120px",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: _vm.$t("apply.shippingCity"),
                              field: "pickupPoint",
                              "min-width": "120px",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: _vm.$t("apply.arrivalAarehouse"),
                              field: "dcName",
                              "min-width": "120px",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: _vm.$t("apply.temperature"),
                              field: "temperatureI18n",
                              "min-width": "120px",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: _vm.$t("apply.unit"),
                              field: "unit",
                              "min-width": "120px",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: _vm.$t("apply.transportaionMethod"),
                              field: "transportaionMethod",
                              "min-width": "120px",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: _vm.$t("apply.effectiveBeginDate"),
                              field: "effectiveBeginDate",
                              "min-width": "120px",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: _vm.$t("apply.priceNotTax"),
                              field: "price",
                              "min-width": "130px",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: _vm.$t("apply.currentLinePrice"),
                              field: "linePrice",
                              "min-width": "120px",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: _vm.$t("apply.currency"),
                              field: "currencyCode",
                              "min-width": "120px",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: "Leadtime",
                              field: "leadTime",
                              "min-width": "120px",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: _vm.$t("common.remarks"),
                              field: "remarks",
                              "min-width": "120px",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              title: _vm.$t("apply.sourcingApprovalStatus"),
                              field: "sourcingLineStatus",
                              "min-width": "140px",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.showAttachmentDialog,
            "append-to-body": "",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAttachmentDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: {
                data: _vm.attachmentList,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "documentName",
                  label: "文件",
                  "min-width": "130px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.downloadFile(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.documentName) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "userName",
                  label: "创建人",
                  "min-width": "130px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "createDate",
                  label: "创建时间",
                  "min-width": "130px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("dateFormatFilter")(
                                scope.row.createDate,
                                "YYYY-MM-DD HH:mm"
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }